import * as palette from "../palette";

import PropTypes from "prop-types";
import React from "react";

export default function StandardMentionsPopover({ children }) {
  return (
    <div
      css={{
        border: `solid 1px ${palette.lightestSealBlue}`,
        backgroundColor: "#ffffff",
        borderRadius: 4,
      }}
    >
      <ul
        css={{
          listStyle: "none",
          margin: 0,
          padding: 0,
        }}
      >
        {children}
      </ul>
    </div>
  );
}

StandardMentionsPopover.propTypes = {
  children: PropTypes.any.isRequired,
};
